<main class="main-wrap-ng">
  <div class="content-blk">
    <div class="container" style="margin-top:48px">
      <h5 class="page-title">
        Embroidery Pending Payments
      </h5>
      <div *ngIf="!flag" class="row">
        <div class="col-sm-12">
          <form class="searchEmbroideryProductForm" [formGroup]="searchEmbroideryProductForm">
            <!-- <i class="fa fa-search" aria-hidden="true"></i>-->
            <input class="form-control" placeholder="Search Product ..." formControlName="searchProduct"
                   ng-model-options="{debounce: 10000}" (change)="fn_searchProduct(searchEmbroideryProductForm)">
          </form>
        </div>
      </div>
      <div class="search-results" infiniteScroll
           [infiniteScrollDistance]="6"
           [infiniteScrollThrottle]="100"
           [infiniteScrollDisabled]="isFullListDisplayed"
           (scrolled)="fn_getEmbroideryProductDetailList()">
        <div *ngIf="!flag" class="sp-admin-list-tbl pro-tble-outer sld-tgl-actn">
          <small class="text-info">
            One time $25 per side will be charged on first order as a Embroidery setup fees. Order will not be fulfilled incase of failed payments for Embroidery setup cost.
          </small><br /><br />
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th width="5" class="text-center">#</th>
                  <th>Product Name</th>
                  <th>Design Code</th>
                  <th *ngIf="userRole=='StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember'">Digitizing Order #</th>
                  <th>$ SetUp Cost</th>
                  <th *ngIf="userRole=='StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember'">Payment Date</th>
                  <th *ngIf="userRole!='StoreAdmin' && userRole != 'StoreOwner' && userRole != 'StoreStaffMember'">Store Owner</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr style="display: none;" [ngStyle]="{'display': isDisplay}">
                  <td colspan="5" class="text-center">
                    No records available
                  </td>
                </tr>
                <tr *ngFor="let item of infoList; let i=index">
                  <td class="text-center">
                    {{i + 1}}
                  </td>
                  <td>
                    <a *ngIf="userRole=='StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember'" class="text-uppercase custm-dsgn" (click)="fn_ViewProduct(item.ProductId ,item.DesignId,1)">{{item.ProductName}}</a>
                    <a *ngIf="userRole!='StoreAdmin' && userRole != 'StoreOwner' && userRole != 'StoreStaffMember'" class="text-uppercase custm-dsgn">{{item.ProductName}}</a>
                  </td>
                  <td>
                    {{item.DesignCode}}
                  </td>
                  <td *ngIf="userRole=='StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember'">
                    {{item.OrderNumber}}
                  </td>
                  <td>
                    {{item.SetUpCost | currency:'USD':'symbol':'1.0-2'}}
                  </td>
                  <td *ngIf="userRole=='StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember'">
                    <span *ngIf="!item.IsPaid">--</span>
                    <span *ngIf="item.IsPaid">
                      {{item.PaymentDate |date:'fullDate'}}
                    </span>

                  </td>
                  <td *ngIf="userRole!='StoreAdmin' && userRole != 'StoreOwner' && userRole != 'StoreStaffMember'">
                    <span>{{item.UserName}}({{item.ImpressId}})</span><br />
                    <small>{{item.UserEmail}}</small>
                  </td>
                  <td>
                    <div *ngIf="!item.IsPaid && !item.PaymentNotRequired && (userRole =='StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember')">
                      <button class="btn btn-sm btn-success special-btn" (click)="fn_Pay(item.DesignId,item.SetUpCost,item.ProductName,item.PngRelativeUrlWithProduct)">
                        Pay
                      </button>
                    </div>
                    <div *ngIf="item.IsPaid && (userRole =='StoreAdmin' || userRole === 'StoreOwner' || userRole === 'StoreStaffMember')">
                      <strong class="text-success">Paid</strong>
                    </div>
                    <div *ngIf="!item.IsPaid && (userRole !='StoreAdmin' && userRole != 'StoreOwner' && userRole != 'StoreStaffMember')">
                      <strong class="text-danger">Not Paid</strong>
                    </div>
                    <div *ngIf="item.PaymentNotRequired">
                      <strong class="text-danger">Payment Not Required</strong>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div *ngIf="flag" class="sp-admin-list-tbl pro-tble-outer sld-tgl-actn">

          <section  class="">
        <div class="row cart-tp-bk">
          <div class="col-sm-9">            
            <h4>
              Please proceed to pay Embroidery setup charge of 
              <strong> {{charge| currency:'USD':'symbol':'1.0-2'}}</strong> 
              for Product <strong> {{ProductName}}</strong>          
            </h4>
          </div>
          <div class="col-sm-3">
            <button mat-button (click)="fn_close()" class="mat-btn mat-back">Back</button>
          </div>
        </div>
        <div class="prcd-crd-wp">
          <div class="row">
            <div class="col-md-5 col-sm-12">
              <mat-card class="mat-card-cmn crt-tl">
                <mat-card-header>
                  <mat-card-title> Card Payment</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="row">

                    <form id="cardForm">
                      <div class="panel">
                        <div class="panel__content">
                          <div class="textfield--float-label alignment">
                            <!-- Begin hosted fields section -->
                            <label class="hosted-field--label">
                              Cardholder Name <span style="color:red">*</span>
                            </label>
                            <div id="cc-name" class="hosted-field"></div>
                            <!-- End hosted fields section -->
                          </div>
                          <div class="textfield--float-label alignment card-number">
                            <!-- Begin hosted fields section -->
                            <label class="hosted-field--label">
                              <span class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none" /><path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" /></svg>
                              </span> Card Number <span style="color:red">*</span>
                            </label>
                            <div id="card-number" class="hosted-field"></div>
                            <div id="card-image"></div>
                            <!-- End hosted fields section -->
                          </div>
                          <div class="row alignment">
                            <div class="col-sm-6">
                              <div class="textfield--float-label">
                                <!-- Begin hosted fields section -->
                                <label class="hosted-field--label">
                                  <span class="icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z" /></svg>
                                  </span>
                                  Expiration Date <span style="color:red">*</span>
                                </label>
                                <div id="expiration-date" class="hosted-field"></div>
                                <!-- End hosted fields section -->
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <div class="textfield--float-label">
                                <!-- Begin hosted fields section -->
                                <label class="hosted-field--label">
                                  <span class="icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" /></svg>
                                  </span>
                                  CVV <span style="color:red">*</span>
                                </label>
                                <div id="cvv" class="hosted-field"></div>
                                <!-- End hosted fields section -->
                              </div>
                            </div>
                          </div>
                          <div class="alignment">
                              <div class="textfield--float-label">
                                <label class="hosted-field--label" for="cc-address">
                                  Address <span style="color:red">*</span>
                                </label>
                                <input id="cc-address" class="hosted-field" name="AddressLine" [(ngModel)]="manualPayment.Address.AddressLine" />
                            </div>
                          </div>
                          <div class="alignment">
                              <div class="textfield--float-label">
                                <label class="hosted-field--label" for="cc-city">
                                  City <span style="color:red">*</span>
                                </label>
                                <input id="cc-city" class="hosted-field" name="City" [(ngModel)]="manualPayment.Address.City" />
                              </div>
                          </div>
                          <div class="row alignment">   
                            <div class="col-sm-6">
                                <div class="textfield--float-label">
                                  <label class="hosted-field--label" for="cc-country">
                                    Country <span style="color:red">*</span>
                                  </label>
                                  <select id="cc-country" class="hosted-field" name="Country" [(ngModel)]="manualPayment.Address.Country" placeholder="Country" (ngModelChange)="getStatesByCountry($event)">
                                    <option value="null" selected>Select country</option>
                                    <option *ngFor="let country of countries" [value]="country.Text">
                                      {{country.Text}}
                                    </option>
                                  </select>
                                </div>
                            </div>                         
                            <div class="col-sm-6">
                              <div class="textfield--float-label">
                                <label class="hosted-field--label" for="cc-state">
                                  State <span style="color:red">*</span>
                                </label>
                                <select id="cc-state" class="hosted-field" name="State" [(ngModel)]="manualPayment.Address.State" placeholder="State">
                                  <option value="null" selected>Select state</option>
                                  <option *ngFor="let state of states" [value]="state.Text">
                                    {{state.Text}}
                                  </option>
                                </select>
                              </div>
                          </div>
                          </div>
                          <div class="row alignment">
                            <div class="col-sm-6">
                              <div class="textfield--float-label">
                                <!-- Begin hosted fields section -->
                                <label class="hosted-field--label">
                                  Postal Code <span style="color:red">*</span>
                                </label>
                                <div id="cc-postal-code" class="hosted-field"></div>
                                <!-- End hosted fields section -->
                              </div>
                            </div>
                          </div>
                        </div>
                        <footer style="text-align:center;" class="panel__footer">
                          <input type="button" value="Pay Now" (click)="tokenizeUserDetails();" class="pay-button" [disabled]="!isCreditCardFormLoad" />
                        </footer>
                        <br />
                      </div>

                    </form>

                  </div>
                </mat-card-content>

              </mat-card>

              
            </div>
            <div class="col-md-2 col-sm-12 center">
              <h2><strong>Or</strong></h2>
            </div>

            <div class="col-md-5 col-sm-12">
              <ngx-paypal [config]="payPalConfig"></ngx-paypal>
            </div>
          </div>
        </div>
          </section>
        </div>
        <app-lazy-loader></app-lazy-loader>
      </div>
    </div>
  </div>
</main>
